
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinbandrakurla() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Bandra Kurla Complex ',
        heading: 'etravo : Corporate Cab Services in Bandra Kurla Complex  ',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Bandra Kurla Complex (BKC), Mumbai’s leading financial and corporate hub. Designed for MNCs, banks, startups, and professionals, the service ensures seamless employee transportation, executive travel, airport transfers, and client meetings. With a fleet of GPS-enabled vehicles and professional chauffeurs, eTravo guarantees safe, punctual, and comfortable corporate mobility across BKC and nearby business districts.",

"top": "Top Corporate Cab Service Areas in Bandra Kurla Complex (BKC) with eTravo",

"topPlaces": [
  {
    "title": "BKC Financial District",
    "description": "Mumbai’s premier business hub housing global banks, MNC headquarters, and financial institutions requiring premium corporate cab services for executives and employees."
  },
  {
    "title": "Jio World Centre Area",
    "description": "A major convention and corporate events zone in BKC where reliable executive transport and client mobility services are essential."
  },
  {
    "title": "G Block & Diamond Bourse",
    "description": "High-security corporate and trading zones with heavy daily professional movement requiring punctual and structured cab services."
  },
  {
    "title": "C-Block Corporate Towers",
    "description": "Home to multinational companies and consulting firms, this area demands regular employee pickup and drop services."
  },
  {
    "title": "US Consulate & Embassy Zone",
    "description": "A sensitive and high-traffic area where executive travel, diplomatic movement, and premium chauffeur services are commonly required."
  },
  {
    "title": "BKC to Lower Parel Corridor",
    "description": "A key corporate travel route connecting two major business districts, heavily used for meetings and inter-office movement."
  },
  {
    "title": "BKC to Andheri SEEPZ Route",
    "description": "A major IT and corporate commuting route used by professionals traveling between tech parks and financial offices."
  },
  {
    "title": "BKC Metro & Airport Connectivity Zone",
    "description": "Important for daily airport transfers and metro-linked corporate commuting, especially for frequent business travelers."
  },
  {
    "title": "Bandra East Business Belt",
    "description": "Surrounding commercial and residential area supporting BKC workforce movement and corporate transport demand."
  },
  {
    "title": "Kurla–BKC Corporate Route",
    "description": "One of the busiest employee commuting corridors connecting major residential zones with BKC offices."
  }
],


"services": [
{
"name": "Corporate Cab BKC Mumbai",
"description": "eTravo offers reliable corporate cab services in BKC Mumbai designed for smooth business travel. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs for daily office commuting and executive travel."
},
{
"name": "Taxi Service BKC",
"description": "Our taxi services in BKC provide quick and dependable transportation for professionals and employees. eTravo ensures clean vehicles, timely service, and a hassle-free travel experience in and around Bandra Kurla Complex."
},
{
"name": "Company Cab BKC",
"description": "eTravo provides company cab services in BKC tailored for corporate needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport BKC",
"description": "Simplify employee commuting with eTravo’s office transport services in BKC. We offer structured and efficient transportation solutions for daily travel across corporate offices."
},
{
"name": "Employee Cab BKC",
"description": "Our employee cab services in BKC are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel BKC",
"description": "eTravo offers corporate travel services in BKC for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab BKC",
"description": "eTravo’s business cab services in BKC are ideal for meetings, client visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport BKC",
"description": "eTravo provides dependable staff transport services in BKC for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient travel coordination."
},
{
"name": "Corporate Taxi BKC",
"description": "Our corporate taxi services in BKC offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi BKC",
"description": "eTravo’s company taxi services in BKC provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop BKC",
"description": "eTravo offers corporate pickup and drop services in BKC for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking BKC",
"description": "Book office cabs in BKC easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab BKC",
"description": "Our business travel cab services in BKC are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute BKC",
"description": "eTravo’s corporate commute services in BKC provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Service BKC",
"description": "eTravo offers professional cab services in BKC with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab BKC Mumbai", "Taxi Service BKC"],
["Company Cab BKC", "Office Transport BKC"],
["Employee Cab BKC", "Corporate Travel BKC"],
["Business Cab BKC", "Staff Transport BKC"],
["Corporate Taxi BKC", "Company Taxi BKC"],
["Corporate Pickup Drop BKC", "Office Cab Booking BKC"],
["Business Travel Cab BKC", "Corporate Commute BKC"],
["Professional Cab Service BKC", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Premium Corporate Cab Services in Bandra Kurla Complex (BKC)",
      "WhyChoosedescription": "eTravo provides professional corporate cab services in Bandra Kurla Complex, Mumbai’s prime business district, ensuring seamless transportation for employees, executives, and corporate clients."
    },
    {
      "WhyChooseheading": "Ideal for Mumbai’s Top Business Hub",
      "WhyChoosedescription": "Bandra Kurla Complex (BKC) is one of Mumbai’s leading financial and commercial hubs, home to multinational companies, banks, and corporate offices, requiring reliable and efficient transport solutions. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Reliable Employee Pickup and Drop Services",
      "WhyChoosedescription": "Corporate cab services in BKC include structured daily pickup and drop with optimized routes, ensuring employees reach offices on time despite Mumbai traffic challenges. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Perfect for Airport Transfers and Executive Travel",
      "WhyChoosedescription": "With Mumbai International Airport located nearby, corporate cab services in BKC are ideal for quick airport transfers, executive travel, and client pickups."
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Requirements",
      "WhyChoosedescription": "From sedans and SUVs to luxury cars, corporate cab providers offer a diverse fleet suitable for daily commute, VIP travel, and corporate events in BKC. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Corporate Etiquette",
      "WhyChoosedescription": "Trained drivers ensure punctual, safe, and professional travel experiences, maintaining high service standards required for corporate clients."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Companies",
      "WhyChoosedescription": "Corporate cab services in BKC offer hourly, daily, monthly, and long-term rental options, allowing businesses to customize travel solutions based on workforce needs."
    },
    {
      "WhyChooseheading": "24/7 Support and Real-Time Assistance",
      "WhyChoosedescription": "Round-the-clock customer support ensures smooth booking, quick issue resolution, and uninterrupted corporate mobility for businesses operating in BKC."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Bandra Kurla Complex?',
            answer: 'Corporate cab services in BKC provide organized transportation for employees, executives, and clients including daily office commute, airport transfers, and business travel.',
        },
        {
            question: 'Why is BKC a major location for corporate cab services?',
            answer: 'BKC is a key financial and business hub in Mumbai with high corporate activity, making reliable transportation essential for daily operations. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'Do corporate cab services in BKC include employee pickup and drop?',
            answer: 'Yes, most services offer structured daily pickup and drop with fixed routes and schedules for employees. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Are airport transfers available from BKC?',
            answer: 'Yes, corporate cab services provide quick airport pickup and drop services due to BKC’s proximity to Mumbai International Airport.',
        },
        {
            question: 'What types of vehicles are available for corporate travel in BKC?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on employee and executive travel needs. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Are corporate cab services available 24/7 in BKC?',
            answer: 'Yes, most providers operate round the clock to support corporate schedules and shift-based work.',
        },
        {
            question: 'Can companies customize corporate travel plans in BKC?',
            answer: 'Yes, businesses can customize routes, timings, and rental plans according to employee and operational requirements.',
        },
        {
            question: 'Do corporate cab services provide safety features?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols to ensure secure employee transportation.',
        },
        {
            question: 'Are monthly corporate cab contracts available in BKC?',
            answer: 'Yes, companies can opt for cost-effective monthly and long-term corporate transport contracts.',
        },
        {
            question: 'How can I book corporate cab services in Bandra Kurla Complex?',
            answer: 'You can book online through service providers or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Mehta',
        designation: 'Operations Head, Financial Firm, BKC Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides excellent corporate cab services in Bandra Kurla Complex. Their punctuality and professional drivers make daily operations smooth for our team.”',
    },
    {
        name: 'Ms. Pooja Shah',
        designation: 'HR Manager, MNC, BKC Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transport in BKC. Their flexible plans and reliable service ensure stress-free commuting for our staff.”',
    },
];








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bandra Kurla Complex",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bkc.jpg",
  "description": "Reliable corporate cab services in Bandra Kurla Complex (BKC), Mumbai by eTravo. Ideal for employee transport, office pickup and drop, business travel, and corporate commute with safe and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-bandra-kurla-complex"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab Services in BKC Mumbai | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab services in Bandra Kurla Complex (BKC), Mumbai with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/139.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinbandrakurla;